import Onshore from "../Assets/Images/On-Shore.png";
import Offshore from "../Assets/Images/Off_Shore.png";
import Hybrid from "../Assets/Images/Hyperledger.png";
import MutlipleBoxes from "../Assets/Images/Home-Blockchain.jpg";

const Blockchain = () => {
  return (
    <div className="relative bg-nightSoft web3-grid-bg text-white overflow-hidden">
      <div className="glow-orb w-[400px] h-[400px] bg-customRed/15 -top-24 right-0"></div>
      <div className="max-w-[1140px] mx-auto p-4 relative">
        <h1 className="text-2xl sm:text-3xl lg:text-4xl font-bold pt-10 sm:pt-16">
          Blockchain Software Development{" "}
          <span className="text-gradient">Outsourcing</span>
        </h1>
        <div className="web3-underline w-[80px] mt-3"></div>
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 py-10 sm:py-16 lg:py-20">
          <div className="flex flex-col gap-4 sm:gap-6">
            <div className="glass-card p-4 sm:p-6 flex flex-col sm:flex-row items-center sm:items-start text-center sm:text-left">
              <div className="shrink-0">
                <img className="w-24 sm:w-32" src={Onshore} alt="" />
              </div>
              <div className="sm:pl-6 pt-4 sm:pt-0">
                <p className="text-xl sm:text-2xl font-bold">
                  Onshore Or Local Outsourcing
                </p>
                <p className="pt-4 text-gray-400">
                  Onshore outsourcing enables ease of communication, significant
                  cost savings and effective quality control.
                </p>
              </div>
            </div>
            <div className="glass-card p-4 sm:p-6 flex flex-col sm:flex-row items-center sm:items-start text-center sm:text-left">
              <div className="shrink-0">
                <img className="w-24 sm:w-32" src={Offshore} alt="" />
              </div>
              <div className="sm:pl-6 pt-4 sm:pt-0">
                <p className="text-xl sm:text-2xl font-bold">Off-Shore Outsourcing</p>
                <p className="pt-4 text-gray-400">
                  Offshore outsourcing enables more efficiency by allowing
                  skilled resources to work on your projects leaving the menial
                  tasks to third parties while you focus on the core of the
                  business and what really matters.
                </p>
              </div>
            </div>
            <div className="glass-card p-4 sm:p-6 flex flex-col sm:flex-row items-center sm:items-start text-center sm:text-left">
              <div className="shrink-0">
                <img className="w-24 sm:w-32" src={Hybrid} alt="" />
              </div>
              <div className="sm:pl-6 pt-4 sm:pt-0">
                <p className="text-xl sm:text-2xl font-bold">Hybrid Outsourcing</p>
                <p className="pt-4 text-gray-400">
                  Hybrid outsourcing offers a blend of both onshore and offshore
                  outsourcing offering greater flexibility, lower costs and a
                  single source of contact and management so that everything can
                  be managed effectively.
                </p>
              </div>
            </div>
          </div>
          <div data-aos="fade-right" className="relative">
            <div className="absolute inset-0 rounded-2xl bg-gradient-to-tr from-customRed/30 via-neonPurple/30 to-neonCyan/30 blur-xl"></div>
            <img
              className="relative rounded-2xl w-full h-auto max-h-[240px] sm:max-h-[340px] object-cover border border-white/10"
              src={MutlipleBoxes}
              alt=""
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Blockchain;
